/* Shoppable Video Carousel - section-shoppable-video-carousel.js */

(function () {
  'use strict';

  function showToast(root, message, isError) {
    var toast = root.querySelector('.svc__toast');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.toggle('is-error', !!isError);
    toast.classList.add('is-visible');
    clearTimeout(toast._timer);
    toast._timer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 2200);
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count], .cart-count-bubble, .cart-count').forEach(function (el) {
      if (count !== undefined && count !== null) {
        el.textContent = count;
      }
    });
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }

  /* Force-play a video, retrying once on the next user gesture if blocked
     (handles browsers that block autoplay until the user has interacted).
     Checks currentSrc (resolved from a <source> child) since video.src is
     often empty when markup uses <source src="..."> instead of the src
     attribute directly. */
  function forcePlay(video) {
    if (!video) return;
    var hasSrc = video.currentSrc || video.src || (video.querySelector('source') && video.querySelector('source').src);
    if (!hasSrc) return;
    if (!video.paused && !video.ended) return; // already playing, nothing to do
    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {
        var resume = function () {
          video.play().catch(function () {});
          document.removeEventListener('touchstart', resume);
          document.removeEventListener('click', resume);
        };
        document.addEventListener('touchstart', resume, { once: true, passive: true });
        document.addEventListener('click', resume, { once: true });
      });
    }
  }

  function addToCart(opts) {
    // opts: { variantId, root, button, redirect }
    var variantId = opts.variantId;
    var root = opts.root;
    var button = opts.button;

    if (!variantId) {
      showToast(root, 'This product is unavailable.', true);
      return;
    }

    if (button) {
      button.classList.add('is-loading');
      button.disabled = true;
    }

    var cartAddUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
      ? window.Shopify.routes.root + 'cart/add.js'
      : '/cart/add.js';

    fetch(cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) {
            throw new Error(err.description || 'Could not add to cart');
          });
        }
        return res.json();
      })
      .then(function () {
        return fetch('/cart.js', { headers: { Accept: 'application/json' } });
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);

        if (button) {
          button.classList.remove('is-loading');
          button.classList.add('is-done');
          var label = button.querySelector('.svc-modal__addbtn-label');
          if (label) label.textContent = 'Added ✓';
        }

        if (opts.redirect) {
          setTimeout(function () {
            window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
              ? window.Shopify.routes.root
              : '/') + 'cart';
          }, 450);
        } else {
          showToast(root, 'Added to cart');
          var drawer = document.querySelector('cart-drawer, #cart-drawer, [data-cart-drawer]');
          if (drawer && typeof drawer.open === 'function') {
            drawer.open();
          } else {
            document.dispatchEvent(new CustomEvent('cart:open'));
          }
          setTimeout(function () {
            if (button) {
              button.classList.remove('is-done');
              button.disabled = false;
              var label2 = button.querySelector('.svc-modal__addbtn-label');
              if (label2) label2.textContent = 'Add to cart';
            }
          }, 1800);
        }
      })
      .catch(function (err) {
        showToast(root, err.message || 'Could not add to cart', true);
        if (button) {
          button.classList.remove('is-loading');
          button.disabled = false;
        }
      });
  }

  /* ---------------- Carousel: autoplay, drag-to-scroll, autoslide, nav ---------------- */

  function setupTrackAutoplayVideos(root) {
    var track = root.querySelector('.svc__track');
    var videos = Array.prototype.slice.call(root.querySelectorAll('.svc__video'));
    if (videos.length === 0 || !track) return;

    function refreshPlayback() {
      var trackRect = track.getBoundingClientRect();
      videos.forEach(function (v) {
        var rect = v.getBoundingClientRect();
        // Consider a card "visible enough to play" if any part of it
        // overlaps the track's viewport, with generous padding so cards
        // peeking at the very edges (first/last items) still count.
        var visible = rect.right > trackRect.left - 60 && rect.left < trackRect.right + 60;
        if (visible) {
          forcePlay(v);
        } else if (!v.paused) {
          v.pause();
        }
      });
    }

    // Run once immediately, then again after video metadata loads (in case
    // dimensions weren't ready yet on first paint).
    refreshPlayback();
    videos.forEach(function (v) {
      v.addEventListener('loadedmetadata', refreshPlayback, { once: true });
      v.addEventListener('canplay', function () { forcePlay(v); }, { once: true });
    });

    var debouncedRefresh = debounce(refreshPlayback, 80);
    track.addEventListener('scroll', debouncedRefresh, { passive: true });
    window.addEventListener('resize', debouncedRefresh);

    // Expose so the autoslide/nav code can force a recheck right after a
    // programmatic scroll, instead of waiting on the debounce.
    track._svcRefreshPlayback = refreshPlayback;
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      clearTimeout(t);
      var args = arguments;
      t = setTimeout(function () { fn.apply(null, args); }, wait);
    };
  }

  function setupDragToScroll(track) {
    var isDown = false;
    var startX = 0;
    var startScroll = 0;
    var moved = false;

    function onDown(clientX) {
      isDown = true;
      moved = false;
      startX = clientX;
      startScroll = track.scrollLeft;
      track.classList.add('is-dragging');
    }

    function onMove(clientX, e) {
      if (!isDown) return;
      var dx = clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      track.scrollLeft = startScroll - dx;
      if (e && e.cancelable) e.preventDefault();
    }

    function onUp() {
      if (!isDown) return;
      isDown = false;
      track.classList.remove('is-dragging');
      // restore snap after a frame so the browser settles to nearest card
      requestAnimationFrame(function () {
        track.style.scrollSnapType = '';
        if (typeof track._svcSyncSlide === 'function') {
          setTimeout(track._svcSyncSlide, 250);
        }
      });
    }

    // Mouse
    track.addEventListener('mousedown', function (e) {
      onDown(e.clientX);
      track.style.scrollSnapType = 'none';
    });
    window.addEventListener('mousemove', function (e) { onMove(e.clientX, e); });
    window.addEventListener('mouseup', onUp);

    // Touch (native scroll already works, but we track "moved" to suppress
    // accidental clicks during a swipe)
    track.addEventListener('touchstart', function (e) {
      onDown(e.touches[0].clientX);
    }, { passive: true });
    track.addEventListener('touchmove', function (e) {
      moved = true;
    }, { passive: true });
    track.addEventListener('touchend', onUp);

    // Suppress the click-to-open-modal if the user was actually dragging.
    track.addEventListener('click', function (e) {
      if (moved) {
        e.stopPropagation();
        e.preventDefault();
      }
    }, true);
  }

  function setupNavAndAutoslide(root) {
    var track = root.querySelector('.svc__track');
    var prev = root.querySelector('.svc__nav--prev');
    var next = root.querySelector('.svc__nav--next');
    if (!track) return;

    setupDragToScroll(track);

    var speed = parseInt(root.getAttribute('data-autoslide-speed'), 10);
    if (isNaN(speed)) speed = 0;

    var slides = Array.prototype.slice.call(track.querySelectorAll('.svc__slide'));
    var slideCount = slides.length;
    var currentSlide = 0;
    var isAnimating = false;

    function refreshNavState() {
      // Manual prev/next buttons stay enabled at all times so they can also
      // be used to wrap around, matching the infinite-loop autoslide.
      if (prev) prev.disabled = false;
      if (next) next.disabled = false;
    }

    // Index-based navigation: scroll to a fixed slide's exact offset rather
    // than scrollIntoView (which can target the wrong scroll container) or
    // relative scrollBy math (which drifts once smooth-scroll animations
    // overlap with a running setInterval).
    function goToSlide(index, isWrap) {
      if (slideCount === 0) return;
      var wrapped = false;
      if (index < 0) { index = slideCount - 1; wrapped = true; }
      if (index >= slideCount) { index = 0; wrapped = true; }
      currentSlide = index;
      var target = slides[currentSlide];
      if (!target) return;

      isAnimating = true;

      if (wrapped) {
        // Wrapping past the end/start: smooth-scrolling backward across the
        // entire track looks broken (like it's rewinding through every
        // slide). Instead, snap instantly to the other end so it reads as
        // a clean, continuous loop rather than a long reverse scroll.
        track.style.scrollSnapType = 'none';
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = target.offsetLeft;
        // restore smooth scrolling + snap on the next frame
        requestAnimationFrame(function () {
          track.style.scrollBehavior = '';
          track.style.scrollSnapType = '';
        });
        isAnimating = false;
        if (typeof track._svcRefreshPlayback === 'function') {
          track._svcRefreshPlayback();
        }
        return;
      }

      var distance = Math.abs(target.offsetLeft - track.scrollLeft);
      var lockTime = Math.min(900, Math.max(350, distance * 0.6));

      track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });

      clearTimeout(goToSlide._settleTimer);
      goToSlide._settleTimer = setTimeout(function () {
        isAnimating = false;
        if (typeof track._svcRefreshPlayback === 'function') {
          track._svcRefreshPlayback();
        }
      }, lockTime);
    }

    function goNext(force) {
      if (isAnimating && !force) return;
      var nextIndex = currentSlide + 1;
      goToSlide(nextIndex, nextIndex >= slideCount);
    }

    function goPrev(force) {
      if (isAnimating && !force) return;
      var prevIndex = currentSlide - 1;
      goToSlide(prevIndex, prevIndex < 0);
    }

    // Keep currentSlide roughly in sync if the user free-scrolls/drags
    // instead of using the buttons, so autoslide resumes from the right spot.
    function syncCurrentSlideFromScroll() {
      if (isAnimating || slideCount === 0) return;
      var trackRect = track.getBoundingClientRect();
      var center = trackRect.left + trackRect.width / 2;
      var closest = 0;
      var closestDist = Infinity;
      slides.forEach(function (slide, i) {
        var r = slide.getBoundingClientRect();
        var slideCenter = r.left + r.width / 2;
        var dist = Math.abs(slideCenter - center);
        if (dist < closestDist) {
          closestDist = dist;
          closest = i;
        }
      });
      currentSlide = closest;
    }
    track._svcSyncSlide = syncCurrentSlideFromScroll;

    if (prev) prev.addEventListener('click', function () { goPrev(true); restartAutoslide(); });
    if (next) next.addEventListener('click', function () { goNext(true); restartAutoslide(); });
    track.addEventListener('scroll', debounce(syncCurrentSlideFromScroll, 150), { passive: true });
    window.addEventListener('resize', refreshNavState);
    refreshNavState();

    var autoslideTimer = null;

    function startAutoslide() {
      if (!speed || speed <= 0) return;
      stopAutoslide();
      autoslideTimer = setInterval(goNext, speed * 1000);
    }

    function stopAutoslide() {
      if (autoslideTimer) {
        clearInterval(autoslideTimer);
        autoslideTimer = null;
      }
    }

    function restartAutoslide() {
      stopAutoslide();
      startAutoslide();
    }

    var resumeTimer = null;
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (evt) {
      track.addEventListener(evt, function () {
        stopAutoslide();
        clearTimeout(resumeTimer);
        resumeTimer = setTimeout(startAutoslide, 4000);
      }, { passive: true });
    });

    if ('IntersectionObserver' in window) {
      var sectionObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            startAutoslide();
          } else {
            stopAutoslide();
          }
        });
      }, { threshold: 0.2 });
      sectionObserver.observe(root);
    } else {
      startAutoslide();
    }
  }

  /* ---------------- Fullscreen modal: prev / center / next reels ---------------- */

  function setupModal(root) {
    var modal = root.querySelector('.svc-modal');
    if (!modal) return;

    var reelPrev = modal.querySelector('.svc-modal__reel--prev');
    var reelCenter = modal.querySelector('.svc-modal__reel--center');
    var reelNext = modal.querySelector('.svc-modal__reel--next');

    var videoPrev = reelPrev.querySelector('.svc-modal__video');
    var videoCenter = reelCenter.querySelector('.svc-modal__video');
    var videoNext = reelNext.querySelector('.svc-modal__video');

    var closeBtn = modal.querySelector('.svc-modal__close');
    var prevBtn = modal.querySelector('.svc-modal__nav--prev');
    var nextBtn = modal.querySelector('.svc-modal__nav--next');
    var thumbImg = modal.querySelector('.svc-modal__thumb-img');
    var titleEl = modal.querySelector('.svc-modal__title');
    var priceEl = modal.querySelector('.svc-modal__price');
    var addBtn = modal.querySelector('.svc-modal__addbtn');
    var addBtnLabel = modal.querySelector('.svc-modal__addbtn-label');
    var backdrop = modal.querySelector('.svc-modal__backdrop');
    var soundBtn = modal.querySelector('.svc-modal__sound');
    var soundOnIcon = modal.querySelector('.svc-modal__sound-on');
    var soundOffIcon = modal.querySelector('.svc-modal__sound-off');
    var likeBtn = modal.querySelector('.svc-modal__like');
    var likeCount = modal.querySelector('.svc-modal__like-count');
    var shareBtn = modal.querySelector('.svc-modal__share');
    var shareCount = modal.querySelector('.svc-modal__share-count');

    var redirectAfterAdd = root.getAttribute('data-redirect-cart') === 'true';

    var cards = Array.prototype.slice.call(root.querySelectorAll('.svc__card'));
    var currentIndex = 0;
    var isMuted = true;
    var liked = false;

    function dataFor(index) {
      var card = cards[index];
      if (!card) return null;
      return {
        videoSrc: card.getAttribute('data-video-src'),
        posterSrc: card.getAttribute('data-poster-src'),
        variantId: card.getAttribute('data-variant-id'),
        title: card.getAttribute('data-product-title'),
        price: card.getAttribute('data-product-price'),
        image: card.getAttribute('data-product-image')
      };
    }

    function loadSide(videoEl, index) {
      var data = dataFor(index);
      videoEl.pause();
      if (data && data.videoSrc) {
        videoEl.muted = true;
        videoEl.loop = true;
        if (videoEl.getAttribute('src') !== data.videoSrc) {
          videoEl.setAttribute('preload', 'auto');
          videoEl.src = data.videoSrc;
          if (data.posterSrc) videoEl.poster = data.posterSrc;
          // Paint a single static frame without playing, so the side peek
          // shows real footage (not a blank box) but only starts moving
          // once it slides into the center position.
          videoEl.addEventListener('loadedmetadata', function onMeta() {
            try { videoEl.currentTime = 0.1; } catch (e) {}
            videoEl.removeEventListener('loadedmetadata', onMeta);
          });
        } else {
          try { videoEl.currentTime = 0.1; } catch (e) {}
        }
      } else {
        videoEl.removeAttribute('src');
      }
    }

function render(index) {
    var data = dataFor(index);
    if (!data) return;

    currentIndex = index;

    var card = cards[index];
    var available = card.getAttribute('data-product-available') === 'true';

      // Center video
      if (data.videoSrc) {
        if (videoCenter.getAttribute('src') !== data.videoSrc) {
          videoCenter.src = data.videoSrc;
          videoCenter.poster = data.posterSrc || '';
        }
        videoCenter.muted = isMuted;
        forcePlay(videoCenter);
      } else {
        videoCenter.removeAttribute('src');
      }

      // Side peeks show a single static frame only — they do NOT play.
      // They'll start playing once the user navigates and they become
      // the new center video (handled by the videoCenter block above on
      // the next render() call).
      loadSide(videoPrev, index - 1 >= 0 ? index - 1 : cards.length - 1);
      loadSide(videoNext, index + 1 < cards.length ? index + 1 : 0);
      reelPrev.style.visibility = 'visible';
      reelNext.style.visibility = 'visible';

thumbImg.src = data.image || '';
thumbImg.alt = data.title || '';
titleEl.textContent = data.title || '';
priceEl.textContent = data.price || '';

addBtn.setAttribute('data-variant-id', data.variantId || '');
addBtn.classList.remove('is-done', 'is-loading');

if (available) {
    addBtn.disabled = false;
    addBtn.classList.remove('sold-out');
    if (addBtnLabel) addBtnLabel.textContent = 'Add to cart';
} else {
    addBtn.disabled = true;
    addBtn.classList.add('sold-out');
    if (addBtnLabel) addBtnLabel.textContent = 'Sold Out';
}

      // Prev/next buttons stay enabled at all times — looping infinitely
      // through the catalog, same as the main carousel.
      if (prevBtn) prevBtn.disabled = false;
      if (nextBtn) nextBtn.disabled = false;

      // Reset per-video like/share counters (cosmetic engagement UI)
      liked = false;
      if (likeBtn) likeBtn.classList.remove('is-liked');
      if (likeCount) likeCount.textContent = Math.floor(Math.random() * 20) + 3;
      if (shareCount) shareCount.textContent = Math.floor(Math.random() * 15) + 1;
    }

    function open(index) {
      render(index);
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';

      // Pause the background section's videos while the popup is open —
      // they're visually hidden behind the modal but would otherwise keep
      // playing/competing for decode resources.
      var bgVideos = root.querySelectorAll('.svc__track .svc__video');
      bgVideos.forEach(function (v) { v.pause(); });
    }

    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      videoCenter.pause();
      videoPrev.pause();
      videoNext.pause();

      // Resume the main section carousel's videos, which were left paused
      // (out of view / behind the modal) while the popup was open.
      var track = root.querySelector('.svc__track');
      if (track && typeof track._svcRefreshPlayback === 'function') {
        track._svcRefreshPlayback();
      }
    }

    function showNext() {
      render(currentIndex + 1 < cards.length ? currentIndex + 1 : 0);
    }
    function showPrev() {
      render(currentIndex - 1 >= 0 ? currentIndex - 1 : cards.length - 1);
    }

    cards.forEach(function (card, index) {
      card.addEventListener('click', function () { open(index); });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          open(index);
        }
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', close);
    if (backdrop) backdrop.addEventListener('click', close);
    if (nextBtn) nextBtn.addEventListener('click', showNext);
    if (prevBtn) prevBtn.addEventListener('click', showPrev);
    if (reelNext) reelNext.addEventListener('click', showNext);
    if (reelPrev) reelPrev.addEventListener('click', showPrev);

    if (soundBtn) {
      soundBtn.addEventListener('click', function () {
        isMuted = !isMuted;
        videoCenter.muted = isMuted;
        soundOnIcon.style.display = isMuted ? 'none' : '';
        soundOffIcon.style.display = isMuted ? '' : 'none';
      });
    }

    if (likeBtn) {
      likeBtn.addEventListener('click', function () {
        liked = !liked;
        likeBtn.classList.toggle('is-liked', liked);
        var current = parseInt(likeCount.textContent, 10) || 0;
        likeCount.textContent = liked ? current + 1 : Math.max(0, current - 1);
      });
    }

    if (shareBtn) {
      shareBtn.addEventListener('click', function () {
        var data = dataFor(currentIndex);
        var url = (data && data.productUrl) || window.location.href;
        if (navigator.share) {
          navigator.share({ title: data ? data.title : '', url: url }).catch(function () {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(function () {
            showToast(root, 'Link copied');
          });
        }
        var current = parseInt(shareCount.textContent, 10) || 0;
        shareCount.textContent = current + 1;
      });
    }

    document.addEventListener('keydown', function (e) {
      if (!modal.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowRight') showNext();
      if (e.key === 'ArrowLeft') showPrev();
    });

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var variantId = addBtn.getAttribute('data-variant-id');
        addToCart({
          variantId: variantId,
          root: root,
          button: addBtn,
          redirect: redirectAfterAdd
        });
      });
    }

    // Swipe / drag support on the whole stage (touch + mouse), so a swipe
    // that starts slightly off the center video still registers.
    var stage = modal.querySelector('.svc-modal__stage');
    (function setupModalSwipe() {
      if (!stage) return;
      var startX = 0;
      var startY = 0;
      var dragging = false;
      var moved = false;

      function onStart(x, y) {
        dragging = true;
        moved = false;
        startX = x;
        startY = y;
      }

      function onEnd(x, y) {
        if (!dragging) return;
        dragging = false;
        var dx = x - startX;
        var dy = y - startY;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
          moved = true;
          if (dx < 0) {
            showNext();
          } else {
            showPrev();
          }
        }
      }

      stage.addEventListener('touchstart', function (e) {
        var t = e.touches[0];
        onStart(t.clientX, t.clientY);
      }, { passive: true });

      stage.addEventListener('touchend', function (e) {
        var t = e.changedTouches[0];
        onEnd(t.clientX, t.clientY);
      }, { passive: true });

      // Mouse drag (desktop testing / trackpad users)
      stage.addEventListener('mousedown', function (e) {
        onStart(e.clientX, e.clientY);
        e.preventDefault();
      });
      window.addEventListener('mouseup', function (e) {
        if (!dragging) return;
        onEnd(e.clientX, e.clientY);
      });

      // Prevent the click-to-open behaviour on side reels from firing right
      // after a drag/swipe gesture.
      stage.addEventListener('click', function (e) {
        if (moved) {
          e.stopPropagation();
          e.preventDefault();
          moved = false;
        }
      }, true);
    })();
  }

  function init(sectionId) {
    var root = document.getElementById(sectionId);
    if (!root || root._svcInitialized) return;
    root._svcInitialized = true;

    setupTrackAutoplayVideos(root);
    setupNavAndAutoslide(root);
    setupModal(root);
  }

  window.ShoppableVideoCarousel = { init: init };

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.svc');
    if (section) {
      section._svcInitialized = false;
      init(section.id);
    }
  });
})();
